var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 614.55 382.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#d4ecff;}.cls-3{fill:#cddcf4;}.cls-4{fill:#b0bdd1;}.cls-5{fill:#dbe9ff;}.cls-6{fill:#f6a397;}.cls-7{fill:#d65863;}.cls-8{fill:#5470d3;}.cls-9{fill:#314ec6;}.cls-10{fill:#504984;}.cls-11{fill:#372d5b;}.cls-12{fill:#ba6454;}.cls-13{fill:#874438;}.cls-14{fill:#fff;}.cls-15{fill:#3f1751;}.cls-16{fill:#ba5e5b;}.cls-17{fill:#ffa6a4;}.cls-18{fill:#e67471;}.cls-19{fill:#282142;}.cls-20{fill:#7f74d1;}.cls-21{fill:#8e5058;}.cls-22{fill:#64364a;}.cls-23{clip-path:url(#clip-path);}.cls-24{fill:#ffc5c7;}.cls-25{fill:#dcedff;}.cls-26{fill:#fe8a8b;}.cls-27{fill:#0c0835;}.cls-28{fill:#252384;}.cls-29{fill:#57aff7;}.cls-30{fill:#c31f2a;}.cls-31{fill:#fb8384;}.cls-32{fill:#699dd1;}.cls-33{font-size:20.46px;fill:#d1c8d9;font-family:BebasKai;}.cls-34{letter-spacing:-0.04em;}.cls-35{letter-spacing:-0.02em;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-67.73 -57.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253,153a71.85,71.85,0,0,1-143.7,0c0-39.68,32.17-85.8,71.85-85.8S253,113.35,253,153Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M671.69,370.72c-26,39.46-70.61,62.65-117.87,62.65H161.57c-78.85,0-123.06-92.18-71.93-144.09s6-96.24,84.84-137.86C250.89,111.09,277,197.05,347.36,140.8s172.87-50.93,195.38,6.37,17.21,77.47,65,90.21,94.44,84.89,65.79,130.52C672.91,368.85,672.3,369.79,671.69,370.72Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M654.25,386.71c-41.32,3.51-69.18,81-172.48,34.41,0,0,11.35-33.81,62.16-54.89S654.25,386.71,654.25,386.71Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M495.88,415.32a288.22,288.22,0,0,1,33.39-14.65c2.85-1.09,5.73-2.07,8.62-3s5.79-1.88,8.7-2.78,5.86-1.69,8.8-2.49c1.47-.39,2.94-.81,4.42-1.18l4.45-1.07,4.46-1,4.49-.88,4.49-.89c1.5-.28,3-.51,4.52-.74,3-.44,6-.95,9.07-1.24s6.06-.75,9.12-.87a152.87,152.87,0,0,1,36.47,1.35,247.39,247.39,0,0,0-36.15,1.9l-2.24.25-2.24.35-4.46.65c-3,.38-5.94,1-8.9,1.51-1.48.29-3,.5-4.45.81l-4.42.92-4.42.92-4.39,1.05-4.41,1c-1.46.35-2.91.74-4.37,1.11l-4.38,1.14c-1.46.37-2.9.82-4.36,1.2-2.91.8-5.82,1.58-8.7,2.48s-5.8,1.7-8.67,2.62C518.78,407.34,507.35,411.3,495.88,415.32Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M659.31,254.9c-50.42,36-27.1,156.82-195.36,175.84,0,0-11.23-52.1,38-118S659.31,254.9,659.31,254.9Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M475.15,416.19a282.71,282.71,0,0,1,26.58-45.33,319.68,319.68,0,0,1,34-40.34,279.13,279.13,0,0,1,40.45-33.92c14.52-9.93,30.19-18.47,46.9-23.79a292.46,292.46,0,0,0-43.53,28.4,419.65,419.65,0,0,0-38.64,34.47,517.73,517.73,0,0,0-34.62,38.61C495.36,387.77,485.12,401.79,475.15,416.19Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.41,376c41,6.41,63.3,85.63,169.63,46.47,0,0-8.94-34.53-58.14-59.14S115.41,376,115.41,376Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M271.37,415.64c-11.16-4.82-22.28-9.57-33.54-14-2.8-1.12-5.64-2.15-8.46-3.23s-5.66-2.08-8.51-3.08c-1.42-.48-2.83-1-4.26-1.51l-4.28-1.44c-1.43-.47-2.86-1-4.29-1.42l-4.33-1.31-4.3-1.36-4.35-1.23-4.35-1.23c-1.44-.41-2.92-.72-4.37-1.11-2.92-.75-5.82-1.55-8.77-2.14l-4.41-1-2.2-.5-2.22-.41a246.29,246.29,0,0,0-35.94-4.44,152.65,152.65,0,0,1,36.48,1.23c3,.32,6,1,9,1.5s6,1.23,9,1.88c1.49.34,3,.67,4.45,1.06l4.42,1.19,4.42,1.2,4.38,1.34,4.36,1.38c1.45.47,2.88,1,4.32,1.48,2.88,1,5.78,2,8.6,3.11s5.69,2.19,8.49,3.39,5.62,2.34,8.38,3.63A285,285,0,0,1,271.37,415.64Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M142.65,249.35c45.4,37.56,15.19,150.54,173.49,179.84,0,0,14.14-48.66-28.12-114.41S142.65,249.35,142.65,249.35Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M306.49,414.64c-8.55-14.29-17.36-28.25-26.81-41.74s-19.53-26.48-30.26-38.9a405.07,405.07,0,0,0-34.3-35.28,282.14,282.14,0,0,0-39.29-30c15.53,6.1,29.85,15.23,43,25.6A264.68,264.68,0,0,1,255,329.22a300.9,300.9,0,0,1,29.48,40.57A263.92,263.92,0,0,1,306.49,414.64Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M409.65,354.53c-5.68,6.75-10.83,17.94-14,19.72S387,376.64,381.94,393s20.62,14.15,20.62,14.15,11-6.32,15.44-21.58l11-9.76Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M389.75,405.39a41.21,41.21,0,0,0,15.39-10.17c7.09-7.48,8-20.8,8-20.8l3.4,6.34,6.79-7.25,3.27-.32,2.41,2.66-11,9.76c-4.44,15.26-15.44,21.58-15.44,21.58A40.75,40.75,0,0,1,389.47,406C389.63,405.63,389.75,405.39,389.75,405.39Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M448.21,295.8c-7.88,5.76-12.58,9.94-16.5,17.77s-28.46,36-30,38.49,13.8,29.15,26.09,35.68c0,0,18.57-21.42,29.27-29.51s7-36.82,2.09-46.48A75.36,75.36,0,0,0,448.21,295.8Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M447.92,347.63v-16s2.09-.83,3.71,4.57a14.8,14.8,0,0,1,.31,6.38l11.95-9c.5,10.06-1.12,20.3-6.85,24.63-10.7,8.09-29.27,29.51-29.27,29.51a39,39,0,0,1-9.78-8.31C425.55,371.9,439.89,357.37,447.92,347.63Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.55,400.87c-2,.64-3.55,1.62-3.55,4.19s.44,6.67,1.42,8.26,6,2.56,6,2.56-.34-10.64-1.4-12.59A5,5,0,0,0,371.55,400.87Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M369.42,413.32a7.12,7.12,0,0,1-.7-1.86,3.45,3.45,0,0,0,2.81,1.23l3.83,1.19c.06,1.2.08,2,.08,2S370.4,414.92,369.42,413.32Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M376.44,397c-2.49.27-5,2.13-5,4.71s-.89,9.77,0,10.92,5.24,4.44,6.75,4.71,4.08-.18,3.73-1S376.44,397,376.44,397Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M371.08,410.68c1.89,2.13,6.71,1.94,6.71,1.94a19,19,0,0,1,2.38,3c.16.44,1,1,1.15,1.46a6.84,6.84,0,0,1-3.11.25c-1.48-.26-5.68-3.42-6.68-4.63l-.45-2Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M385.75,392.73c-7.63.43-9.05,1.14-9.31,4.25s-.09,12.17.88,14.48,1.51,4.35,2.76,5.59a4.82,4.82,0,0,0,3.1,1.25s4.18-6.13,4.36-11.28S385.75,392.73,385.75,392.73Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M381.36,413.2a46.09,46.09,0,0,0,1.36-11.42c0-2.65,2.5,11.2,1.4,15-.55.94-.94,1.52-.94,1.52a4.82,4.82,0,0,1-3.1-1.25c-1.25-1.24-1.78-3.28-2.76-5.59a5.66,5.66,0,0,1-.18-.54C377.64,412.22,379.22,413.07,381.36,413.2Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M402.46,408.35c-.48,4.24-6,5.77-6.66,7.9s-.18,4.09-1.25,4.62-5.5-1.95-5.33-4.79a5.53,5.53,0,0,1-3.73,2.84c-2.57.44-3.19-1.44-2.75-4.27a36.3,36.3,0,0,0,.27-7.72c-.09-3.38-.89-6.48.62-10.21s3.55-7,7.64-6.4,6.57,5.77,8.79,7.55S403,403.64,402.46,408.35Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M389.22,416.08c.25-5.4.53-9.82.53-10.69s-.28-6.6,1.76-6.94c.31-.06,4.79,2.78,4.87,4.7s0,5.35-1.39,6.33S389.22,416.08,389.22,416.08Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M574.3,307.31C566.2,297,563.42,296,555.06,291.12s-40-17.24-46.57-18.81S475.63,283,467,286.94s-19.63,7.77-21.51,11.59c-6.27,12.78,6.15,30.89,6.22,68.84,0,19.88,4.56,64.58,4.56,64.58s99.5.18,100.89-1.91S562,356.58,563.76,342,574.3,307.31,574.3,307.31Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M445.85,318.54a48.81,48.81,0,0,1-1.56-7.31,49.9,49.9,0,0,1-.58-7.45,48.58,48.58,0,0,1,1.57,7.31A51.26,51.26,0,0,1,445.85,318.54Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M483.05,303.59c-3.84-1.44-12.95,1.06-14.61,1.64s1-6.54,2-7.42,2.54-2.94,5.55-2,5.52,4.37,6,5.5A16.13,16.13,0,0,0,483.05,303.59Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M515.08,309.53c-1.37-.07-9.36-3.75-11.28-4.66s-10.59-1.34-16.42.29c0,0,11.22-7.58,17.75-7.52s9,2.42,9.53,4.51A43.47,43.47,0,0,1,515.08,309.53Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M472.31,415.94c1.07-1,66.05,1.05,67.35-5.74s2.21-19.14,2.21-19.14c-7.82,4.18-19.18,2.44-19.18,2.44,7.57-2.48,18.54-14.9,19.06-18.56,1.61-11.26-4.41-42.31-4.41-42.31l4.41-8.87,5.16-2.87a71.55,71.55,0,0,1,18.14,13.83,73.16,73.16,0,0,0-1.29,7.23c-1.64,13.79-4.83,78-6.35,87.07-20.13.74-56.61,2.08-81,2.91-11.83,0-20.13,0-20.13,0s-.15-5.88-.51-14.31C462.56,417.24,471.65,416.59,472.31,415.94Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M485.51,305.48c7-.85,18.28-6.92,22.72-4.83s5.48,7.44,6.4,8.35,4.83-3.65,4.83-14.88.34-22.73-7.93-24.29-29.68,6.53-34,9.8a20.36,20.36,0,0,0-7.31,9.74c-1.17,3.18-4.31,16-2.87,16.11s5.48-8.23,8.49-8.49S483.61,305.71,485.51,305.48Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M481.52,295.42c-1.79-4.24-3.75-8-3.68-10.9s.72-5,4-5.87,4.64.85,4.83,5.28S481.52,295.42,481.52,295.42Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M507.12,287.51c6.82-6.19,7.59-13.11,7-14.54s-3.46-2.48-3.46-2.48-1.11,4.5-.46,5.61S507.12,287.51,507.12,287.51Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M496.25,302.48a34.4,34.4,0,0,1,5.17-1.81,18,18,0,0,1,5.5-.65,5,5,0,0,1,2.78.93c.74.7,1.3,1.33,1.93,2a21.35,21.35,0,0,1,2.89,4.74,2.24,2.24,0,0,0,.57.85s0,0,.15-.06a2.26,2.26,0,0,0,.38-.38,15.45,15.45,0,0,0,1.33-2.26,18.47,18.47,0,0,0,1.61-5.06,43.51,43.51,0,0,0,.66-5.37c.16-1.81.21-3.62.24-5.44a47.13,47.13,0,0,1-.14,10.94,17.77,17.77,0,0,1-1.52,5.35,14.93,14.93,0,0,1-1.42,2.45,3.52,3.52,0,0,1-.58.58,1.39,1.39,0,0,1-.49.22,1,1,0,0,1-.64-.07,1.78,1.78,0,0,1-.68-.65,6.25,6.25,0,0,1-.37-.65,20.53,20.53,0,0,0-2.72-4.58,26.38,26.38,0,0,0-1.76-2,4.44,4.44,0,0,0-2.3-.85,17.79,17.79,0,0,0-5.32.37A44.18,44.18,0,0,0,496.25,302.48Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M480.17,300.14a22.21,22.21,0,0,0-2.33-1.9,7.12,7.12,0,0,0-1.24-.72,2.82,2.82,0,0,0-.62-.18,1,1,0,0,0-.25,0c-.06,0-.1,0-.22.11a13.73,13.73,0,0,0-4.11,4.1c-.57.79-1.06,1.69-1.73,2.51a7.23,7.23,0,0,1-1.14,1.14,1.72,1.72,0,0,1-.89.41.93.93,0,0,1-.66-.21,1.06,1.06,0,0,1-.3-.48,4,4,0,0,1-.08-1.66c.07-.52.16-1,.27-1.52a26.26,26.26,0,0,1,.89-2.9c-.14,1-.32,2-.4,3a12.24,12.24,0,0,0-.1,1.47,3.49,3.49,0,0,0,.15,1.34.4.4,0,0,0,.09.14h.05a1.12,1.12,0,0,0,.44-.26,5.93,5.93,0,0,0,.94-1c.58-.76,1.06-1.63,1.65-2.49a15.5,15.5,0,0,1,2-2.37,10.69,10.69,0,0,1,2.53-1.82,1.57,1.57,0,0,1,.46-.18,1.68,1.68,0,0,1,.5,0,2.78,2.78,0,0,1,.81.3,7.55,7.55,0,0,1,1.27.93A16.16,16.16,0,0,1,480.17,300.14Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480.56,269.92c0,2.76.13,5.51.41,8.25.71,6.74,0,15.62.55,17.25.59,1.83,4.12,8.36,4.12,8.36s6.27-2.87,8.88-6,6-3.29,10.57-7.91,7.68-12,6.66-18.07c-.13-.78-.93-8.6-1.11-16.7s-8.68-14.24-16.78-14.24-12.94,12-13.19,20.1C480.57,264.28,480.55,267.4,480.56,269.92Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M510.64,255.09c.18,8.1,1,15.92,1.11,16.7a16.33,16.33,0,0,1-.16,5.9c-1.79.33-24.85.89-30.82-1.89-.14-2-.2-3.92-.21-5.88,0-2.52,0-5.64.11-9a30.49,30.49,0,0,1,2.7-11.19l19-6.72C507,245.52,510.53,249.9,510.64,255.09Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M466.36,221.38c-12.25,0-16.84,9.41-16.84,16.47,0,6.32,2,16.46,16.84,16.46,7.4,0,12.41-7.37,12.41-16.46S473.76,221.38,466.36,221.38Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M465.82,225.41c-9.25,0-12.71,7.11-12.71,12.44,0,4.77,1.53,12.43,12.71,12.43,5.59,0,9.37-5.57,9.37-12.43S471.41,225.41,465.82,225.41Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M450.9,226.94c.73,4.29,2.85,5.93,3.8,11.72s-1.58,14.19,2.19,21.52,9.88,16.95,13.41,17.36,31.76-4.37,41.29-23.32c2.74-5.44,8.58-26.76,3.58-39.79s-13.14-25-31.94-25.32S447.07,204.19,450.9,226.94Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M466.63,250.4a3.34,3.34,0,0,0,2.61-1,2.64,2.64,0,0,0,.48-2,6,6,0,0,1-5.08,1.1C464.42,249.79,465.46,250.37,466.63,250.4Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M499.9,226.94a12.65,12.65,0,0,0-3.7-7s-7.19-3-12.75-3.53a72.73,72.73,0,0,1-11.25-2.17s1.76,4.47,4.74,6.37c0,0-13.29-.67-17.49-4.6,0,0,.81,3.24,1.63,5.41,0,0-6.51-.67-8.55-3.24,0,0-1.63,5.67-1.63,8.8,0,0-7.82-10.7-5.83-19.2s4.7-11.76,4.7-11.76a42.55,42.55,0,0,1-8.68,0s7.24-6.32,12.66-10.48,21.7-4.34,21.7-4.34-1.27-4.34.18-11.21c0,0,7,10.21,14.33,13.33s6.38,2.86,14.19,4.83,15.24,7,18.36,11.17,6.51,8.55,8.54,9.23c0,0-4.88-.68-7.32-2.72,0,0,4.07,9.25-1.31,21.15s-18.86,8.38-21.47,5.75A5.1,5.1,0,0,1,499.9,226.94Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M501,232.69a5.1,5.1,0,0,1-1.05-5.75,12.66,12.66,0,0,0-2.62-5.87A79.48,79.48,0,0,0,495,185.39a39.86,39.86,0,0,0,6.17,2,67,67,0,0,1,8.17,17.72c2.36,7.88,3.51,16.39,1.3,24.31a26.28,26.28,0,0,1-2.43,5.86C504.82,235,502,233.75,501,232.69Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M504.63,222.52s.93-29.75-14.67-39.24A20.36,20.36,0,0,1,509,194c6.91,12.07,6.45,22.42,6.27,28.22S504.63,222.52,504.63,222.52Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M509.38,221.38c12.25,0,16.84,9.41,16.84,16.47,0,6.32-2,16.46-16.84,16.46-7.4,0-12.41-7.37-12.41-16.46S502,221.38,509.38,221.38Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M502.78,237.85c0-8.08,5.33-14.62,11.9-14.62s11.54,6.54,11.54,14.62-5,14.61-11.54,14.61S502.78,245.92,502.78,237.85Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 448.52,
    cy: 180.05,
    rx: 8.1,
    ry: 9.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M478.33,254.31c-3.31,1.82-14.12,2.43-14.86,2.33s.78,8.1,3.43,8.41,7.94-.41,10.15-2.53S478.33,254.31,478.33,254.31Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M477.64,256.7l-.52-1.88c-3.64,1.24-10.81,1.77-13,1.82a15,15,0,0,0,.95,3.3c.07,0,0,.11.05.06A16.09,16.09,0,0,0,477.64,256.7Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M476.87,234.68c0-1.5.74-2.71,1.65-2.71s1.65,1.21,1.65,2.71-.73,2.71-1.65,2.71S476.87,236.18,476.87,234.68Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M458,236c0-1.5.64-2.72,1.42-2.72s1.42,1.22,1.42,2.72-.63,2.71-1.42,2.71S458,237.44,458,236Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M486.11,224.11a17.17,17.17,0,0,0-7.45-2,9.49,9.49,0,0,0-4,.39,7.34,7.34,0,0,0-3.28,2.29l.1.16c1.36-.15,2.49-.48,3.68-.64s2.28-.6,3.5-.7a21.1,21.1,0,0,1,7.34.66Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M453.22,227.61a7.29,7.29,0,0,1,1.83-.44,16.06,16.06,0,0,1,1.83-.12,8,8,0,0,0,1.82.06,4.77,4.77,0,0,0,.93-.25,3.9,3.9,0,0,0,1-.49l0-.19a3.56,3.56,0,0,0-1.93-1,4.53,4.53,0,0,0-2,.33,9.21,9.21,0,0,0-1.92.71,6.32,6.32,0,0,0-1.65,1.19Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M472.31,422.38c0,.42-.58,1-2,1H425c-5.22,0-6.44-2.06-4.87-4.67s8.18-8.36,24.54-12.36,25,5.35,27.63,9.57C474.26,419,472.31,422.38,472.31,422.38Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M419.75,419.51c.9,3,35.46,1.43,35.46,1.43s-3.51-4.73-7.38-4.86-5.76,1.21-10.95,2.1-1.35-2.11-1.35-2.11-3.67-.82-5.16-2c0,0,8.56-2.53,12.15-3.12s12.73-.2,13.9,0c.84.14,5.05-2.31,10.15-1.08a22.63,22.63,0,0,1,5.74,6c1.95,3.09,0,6.44,0,6.44,0,.42-.58,1-2,1H425C420.32,423.4,418.87,421.74,419.75,419.51Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M567.55,394.06s-32.2,5-49.66,8.11c-16.54,3-30.82,4.24-34.86,3.46s-17.89-5.88-22.33-7.71-13.32-2.87-17.89-1.43-8.31,3-10.14,3-1.48,3,1,3.57a18.15,18.15,0,0,0,4.61.52s-8.27,4.53-9.75,5,.28,3.14,2.28,3c0,0-1.76,1.05-1.15,2.09s5,1.05,5,1.05-5.31,2.61-.88,3.65,9.75-3.92,11.93-4.35,7.23-.17,9.66,1.65,12.89,10.27,27.16,5.23c0,0,96.9,3.92,106.56,3.92s15.5-8.54,12.4-25A124.78,124.78,0,0,0,592.31,371l-33.42,2.35Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M445.87,401a12.44,12.44,0,0,1,2-.35Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M438.24,403.58a18.15,18.15,0,0,1-4.61-.52,2.83,2.83,0,0,1-1.55-1c2.71,1.2,6,.44,7.87,0,1.15-.27,4-.79,5.92-1.13A44.63,44.63,0,0,0,438.24,403.58Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M438.67,407.5a4.69,4.69,0,0,1,.5-.21Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M428.51,410.48s1,.87,3,0c1.67-.73,5.74-2.4,7.16-3-1.78.81-6.62,3.53-7.9,4A2.78,2.78,0,0,1,428.51,410.48Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M433.51,413.68c1.48-.44,4.57-2.31,6.46-3.2a12.93,12.93,0,0,1,4.31-1,8.88,8.88,0,0,0-2.61,1c-1.89.93-7.08,4.16-7.08,4.16a16.36,16.36,0,0,1-4.22-.54A12.61,12.61,0,0,0,433.51,413.68Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M461.06,415.81c2.74,1.7,10.84,3.92,15.67,3a7.34,7.34,0,0,0,5.87-5L484,418.2s67.2,1.92,80.87,1.31c13.51-.61,34.58-.92,37.33-9-.75,9.42-5.85,14.26-13.13,14.26-9.66,0-106.56-3.92-106.56-3.92-14.27,5-24.72-3.4-27.16-5.23-2-1.52-5.85-1.95-8.33-1.81h0C450.67,412.49,458.32,414.11,461.06,415.81Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M567.55,394.06s12.59-1.71,15.12-2l-1.92-7.83-15.93,3.22Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M601.2,372.13a3.28,3.28,0,0,1-.77,3.53c-5.85,5.71-13.53,13.49-21.43,14.69-8.62,1.31-23,1.83-23.77,0s-3.65-25.07-8.88-36.82-8.61-17.76-9.92-24.55,10.45-22.72,15.67-24,17.23-2.09,22.2,2.35,8.61,21.41,14.36,34.21C593.29,351.84,599.12,366.76,601.2,372.13Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M568.87,304.73c-1.59-.18-3.19-.32-4.79-.35a47.81,47.81,0,0,0-4.79,0,41.23,41.23,0,0,0-4.73.54c-.79.12-1.56.3-2.33.48a11,11,0,0,0-2.11.86,14.36,14.36,0,0,0-2,1.24c-.59.52-1.21,1-1.75,1.57a31.24,31.24,0,0,0-3.09,3.59,46,46,0,0,0-2.65,4c-.85,1.36-1.61,2.77-2.34,4.21a40,40,0,0,1,4.36-8.64,26.62,26.62,0,0,1,3-3.82,22.24,22.24,0,0,1,1.82-1.67,14.34,14.34,0,0,1,2.09-1.35,11.39,11.39,0,0,1,2.35-.93c.8-.17,1.59-.36,2.4-.46a30.59,30.59,0,0,1,4.86-.37A39.25,39.25,0,0,1,568.87,304.73Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M594.68,376.94c0-4.17-8.86-42.42-16.64-63.74h0c3.31,7.28,6.4,18.92,10.62,28.32,4.63,10.32,10.46,25.24,12.54,30.61a3.28,3.28,0,0,1-.77,3.53c-2.24,2.19-4.75,4.68-7.44,7C593.19,382.45,594.72,380.84,594.68,376.94Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M174.62,333.85a6.19,6.19,0,0,0,.74,3.72,26.73,26.73,0,0,1,3.28,13.64c-.09,3.11-.73,6.3.11,9.3,1.47,5.17,6.93,8.37,8.69,13.46,1.55,4.5.11,10.17,3.34,13.67a3,3,0,0,0,3.15,1.09,3.87,3.87,0,0,0,1.36-1.13c3.71-4.21,7.68-9.34,6.54-14.84-1.08-5.17-6.4-8.66-7.41-13.84-.83-4.23,1.34-9.12-1.09-12.68-.67-1-1.62-1.74-2.36-2.68-2.88-3.7-1.81-9.6-5.14-12.92a7.66,7.66,0,0,0-3.91-2,6.09,6.09,0,0,0-7.3,5.22Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M195.74,399.51c.22-2.76.32-5.52.42-8.28-.12-2.76-.27-5.51-.51-8.27s-.54-5.51-1-8.25a35.39,35.39,0,0,0-2.29-8c-2-5.06-3.62-10.35-5.25-15.59l-2.37-7.89c-1-2.58-1.92-5.17-2.84-7.77.4,2.74,1,5.43,1.58,8.14l2.37,7.91c1.64,5.27,3.24,10.52,5.29,15.7a33.61,33.61,0,0,1,2.21,7.78c.48,2.69.79,5.41,1,8.13s.39,5.47.5,8.21Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M181.19,343.64a6.43,6.43,0,0,0,1.67,1.66,9.44,9.44,0,0,0,1,.54,4,4,0,0,1,1,.66l.13.11.11-.17c.26-.4.58-.77.83-1.18s.5-.82.72-1.24a9.81,9.81,0,0,0,.89-2.76l-.08,0a9.45,9.45,0,0,0-1.65,2.37c-.21.43-.38.88-.56,1.32s-.28.93-.44,1.38l.24-.06a4,4,0,0,1-.92-.72,11,11,0,0,0-.82-.85,6.47,6.47,0,0,0-2.08-1.1Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M181.86,353.06c.47.39,1,.81,1.47,1.17a12.41,12.41,0,0,0,1.59,1c.57.27,1.17.49,1.72.79a11.52,11.52,0,0,1,1.53,1.09l.18.14.17-.23a27.62,27.62,0,0,0,2-3.12,18.58,18.58,0,0,0,1.45-3.43l-.07,0a19.34,19.34,0,0,0-2.19,3,27.75,27.75,0,0,0-1.63,3.33l.35-.09a11.11,11.11,0,0,1-1.66-.91c-.51-.35-1-.79-1.48-1.17a11,11,0,0,0-1.62-1,7.16,7.16,0,0,0-1.8-.66Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M185.21,365.5a7.83,7.83,0,0,0,1.69,1.26,6.48,6.48,0,0,0,1.93.76,5,5,0,0,1,1.86.9c.55.42,1.1.88,1.65,1.24l.42.28.31-.47a13.37,13.37,0,0,0,1.2-2.16,11.72,11.72,0,0,0,.77-2.39l-.1-.05a11.63,11.63,0,0,0-1.6,1.93,13,13,0,0,0-1.18,2.17l.73-.19a12.6,12.6,0,0,0-2-.78,5.64,5.64,0,0,1-1.82-1,5.93,5.93,0,0,0-1.79-1.06,7.33,7.33,0,0,0-2.06-.52Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M200.12,400.05c2.16-.36,10.24-2.94,9.67-5.05-2.42-9.05-4.84-19.32,3.54-23.75,4-2.13,9.1-3.21,11.4-7.15s.62-9.23-1.5-13.42-4.68-8.68-3.77-13.29c.95-4.83,5.52-8.39,6.25-13.25,1-6.65-5.46-12-11.66-14.6-2.1-.88-4.42-1.63-6.64-1.1a8.08,8.08,0,0,0-4,2.62c-4.36,4.87-4.18,12.21-3.19,18.67s2.52,13.27.09,19.33c-1.73,4.31-5.43,8.36-4.44,12.89.4,1.82,1.53,3.4,2,5.21,1.17,4.87-2.88,9.26-4.74,13.91a17.08,17.08,0,0,0,3.79,17.9,3.77,3.77,0,0,0,3.29,1.08Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M199.36,400.15c.5-3.59,1-7.16,1.64-10.7.15-.89.34-1.77.48-2.66s.21-1.78.36-2.66c.27-1.78.57-3.54.9-5.3a70.31,70.31,0,0,1,2.71-10.33,21.1,21.1,0,0,1,2.26-4.68,6.45,6.45,0,0,1,1.63-1.73,8.52,8.52,0,0,0,2.18-2,8.94,8.94,0,0,0,1.57-5.62,27,27,0,0,0-.81-5.52c-.83-3.55-1.87-7-2.45-10.48a24,24,0,0,1,.21-10.38c.28-.82.51-1.65.77-2.48a18.77,18.77,0,0,1,1-2.41,25,25,0,0,1,3-4.43,20.38,20.38,0,0,0-3.85,3.91A18.45,18.45,0,0,0,209.5,325a9.69,9.69,0,0,0-1,2.62,25.49,25.49,0,0,0-.25,11.09c.6,3.63,1.66,7.11,2.47,10.58a26,26,0,0,1,.77,5.18,7.38,7.38,0,0,1-1.25,4.61,6.94,6.94,0,0,1-1.77,1.64,8,8,0,0,0-2.08,2.16,23.21,23.21,0,0,0-2.45,5,71.76,71.76,0,0,0-2.77,10.59q-.51,2.67-.92,5.36c-.12.9-.29,1.79-.4,2.69s-.13,1.81-.18,2.72C199.43,392.91,199.3,396.53,199.36,400.15Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M213.67,329.49a6.95,6.95,0,0,0-2.89,2.3,9.09,9.09,0,0,1-1.08,1.5,13.53,13.53,0,0,1-1.41,1.2l.64,0c-.22-.47-.48-.9-.73-1.35a12,12,0,0,0-.8-1.28c-.28-.42-.6-.82-.9-1.22s-.65-.78-.93-1.2h-.11a4.42,4.42,0,0,0,.32,1.59,10.07,10.07,0,0,0,.66,1.41,9.93,9.93,0,0,0,.84,1.3c.32.41.62.82,1,1.2l.4.42.24-.38a9.92,9.92,0,0,1,1-1.51,7.27,7.27,0,0,1,1.42-1.16,6.8,6.8,0,0,0,1.29-1.28,11.26,11.26,0,0,0,1.08-1.5Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M205.84,343.2a8.57,8.57,0,0,0,1,1.7,12.56,12.56,0,0,0,1.24,1.49c.46.44,1,.82,1.5,1.23a8.3,8.3,0,0,1,1.31,1.4l.13.16.17-.14a15,15,0,0,0,1.69-1.55c.48-.55,1-1.08,1.45-1.66s.89-1.17,1.29-1.78.78-1.25,1.2-1.85l-.06-.09a7.72,7.72,0,0,0-1.82,1.36,18,18,0,0,0-1.52,1.63c-.47.57-.87,1.19-1.31,1.78s-.79,1.29-1.19,1.8l.3,0a7.9,7.9,0,0,1-1.33-1.38c-.37-.52-.71-1.08-1.1-1.58s-.87-.93-1.33-1.38a12.93,12.93,0,0,0-1.5-1.23Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M220.24,353.78c-.68.8-1.38,1.53-2.11,2.24s-1.5,1.32-2.25,2a7.25,7.25,0,0,1-2.63,1.53,9.74,9.74,0,0,1-3,.34l.45.32a19.77,19.77,0,0,0-.72-2.45,13.57,13.57,0,0,0-1-2.34,11.35,11.35,0,0,0-1.49-2.11,5.73,5.73,0,0,0-2.1-1.51l0,.1a8,8,0,0,1,1.51,1.9,22.92,22.92,0,0,1,1.13,2.14l1,2.22c.33.75.62,1.53.91,2.28l.14.36.31,0a17.57,17.57,0,0,0,3.08-.88c1-.38,2-.72,2.95-1.21a7.89,7.89,0,0,0,2.48-2,8.06,8.06,0,0,0,1.55-2.79Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M200.76,361.88a6.12,6.12,0,0,0-.42,2.51,8.32,8.32,0,0,0,.47,2.52,9,9,0,0,0,1.3,2.2l1.5,2,.11.14.18-.13a24.86,24.86,0,0,1,2.62-1.48c.89-.47,1.8-.88,2.72-1.27s1.82-.79,2.76-1.14,1.9-.69,2.87-1.06l0-.1a14.33,14.33,0,0,0-6.08,1.23,19.62,19.62,0,0,0-2.73,1.52,18.4,18.4,0,0,0-2.41,2l.28,0a7.27,7.27,0,0,1-1.39-2,17.32,17.32,0,0,1-.79-2.26,18.17,18.17,0,0,1-.86-4.7Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M185.48,423.4h23.06c2.14,0,4-1.85,4.28-4.35l3.65-28.36c.4-3.1-1.63-5.9-4.28-5.9H181.83c-2.65,0-4.68,2.8-4.28,5.9l3.65,28.36C181.52,421.55,183.34,423.4,185.48,423.4Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M181.83,384.79h15.52c-2.65,0-4.68,2.8-4.28,5.9l3.65,28.36c.32,2.5,2.14,4.35,4.28,4.35H185.48c-2.14,0-4-1.85-4.28-4.35l-3.65-28.36C177.15,387.59,179.18,384.79,181.83,384.79Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M392,415.62H295.58a1.75,1.75,0,0,0-1.76,1.75v4.28a1.75,1.75,0,0,0,1.76,1.75H392Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M416.83,421v1.74a.68.68,0,0,1-.68.67H391.86a1.36,1.36,0,0,1-1.37-1.36V417a1.36,1.36,0,0,1,1.52-1.36l24.21,4.69A.68.68,0,0,1,416.83,421Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M223.49,251.72H403.72a8.64,8.64,0,0,1,8.13,5.72L451.27,366.9c1.65,5.64-2.48,9.87-9.12,10.59-1,.1-5.86-2.07-13.46-5.65H267.57a8.64,8.64,0,0,1-8.14-5.71l-35.61-98.88-9.45-4.94S212.14,251.72,223.49,251.72Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M398.07,257.36H217.85a3.7,3.7,0,0,0-3.48,4.95l39.42,109.46a8.64,8.64,0,0,0,8.13,5.72H442.15a3.7,3.7,0,0,0,3.48-4.95L406.21,263.08A8.65,8.65,0,0,0,398.07,257.36Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "289.66 319.69 281.66 290.01 251.34 319.69 289.66 319.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M313.51,295.8c.79,4.9,4,6.87,7.75,6.87a5.85,5.85,0,0,0,6-6.87,8.26,8.26,0,0,0-7.75-6.86A5.86,5.86,0,0,0,313.51,295.8Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "330.48 301.47 328.16 295.04 331.08 295.04 333.39 301.47 330.48 301.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "324.35 301.47 322.03 295.04 324.94 295.04 327.26 301.47 324.35 301.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "318.21 301.47 315.89 295.04 318.81 295.04 321.13 301.47 318.21 301.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "312.08 301.47 309.76 295.04 312.67 295.04 314.99 301.47 312.08 301.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "224.94 301.47 222.62 295.04 225.54 295.04 227.85 301.47 224.94 301.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "218.81 301.47 216.49 295.04 219.4 295.04 221.72 301.47 218.81 301.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "212.67 301.47 210.36 295.04 213.27 295.04 215.59 301.47 212.67 301.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "206.54 301.47 204.22 295.04 207.13 295.04 209.45 301.47 206.54 301.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M296.53,412.83c1.78-5.12,23.34-74.71,23.34-74.71h27.69l1.83,9.69s-18.56,59.9-20.34,65q-.21.59-.39,1.17h0c-1.62,5,2.67,5,7.5,5H385v4.42H303.64C293.86,423.4,294.75,417.94,296.53,412.83Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M347.56,338.12S326,407.71,324.21,412.83s-2.67,10.57,7.12,10.57H298.81c-9.78,0-8.89-5.46-7.12-10.57S315,338.12,315,338.12Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M340.78,338.12c-2.15-.1-4.29-.15-6.44-.22s-4.29-.09-6.43-.13-4.29-.1-6.44-.1l-6.43,0h-.36l-.11.35c-.9,2.8-1.78,5.6-2.62,8.42l-2.57,8.45c-1.65,5.65-3.3,11.3-4.81,17,2-5.54,3.82-11.14,5.66-16.73l2.67-8.41c.9-2.8,1.76-5.62,2.61-8.43l-.47.34,6.43,0c2.15,0,4.29-.06,6.44-.09s4.29-.07,6.43-.14S338.63,338.22,340.78,338.12Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M152.18,440.49H629.52a8.54,8.54,0,0,0,8.54-8.54h0a8.54,8.54,0,0,0-8.54-8.55H152.18a8.55,8.55,0,0,0-8.55,8.55h0A8.55,8.55,0,0,0,152.18,440.49Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M152.18,440.49H629.52a8.54,8.54,0,0,0,8.54-8.54H143.63A8.55,8.55,0,0,0,152.18,440.49Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 181.19,
    cy: 153.03,
    r: 71.85,
    transform: "translate(-76.84 236.77) rotate(-76.83)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M282.22,210.37c1.36,6.85-5,12.95-7,14.09s-15.33,6.47-23.34,6.66-18.58-16.75-14.25-18.66,33.8-4,37-4S282.22,210.37,282.22,210.37Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M261.21,206.75c-3.5,20.57-11.8,36.56-14.39,36.85s-27.49-8.29-34.35-11.43,2.1-51.41,6.37-50.56,13.64,10.12,21.37,14.57S261.21,206.75,261.21,206.75Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M220.2,215.3c2.4,4.12,22.19,14.55,33.08,18.35-2.69,6.07-5.23,9.81-6.46,9.95-2.22.24-20.79-6-30.39-9.78A146.25,146.25,0,0,1,220.2,215.3Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M282.25,209.42c.19,8.15-7.16,9.33-15.95,7.23s-23.17-21.9-29.56-30.85S218.41,160.91,216,159.48s-8.13-2.19-13-10.24,1.53-24.9,3.82-26.9S228.69,127,231,130.4s-1.62,21.51-.93,23.79,17.38,20.95,24.66,25.52S282.1,203.51,282.25,209.42Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M216.84,135.81c-2.31-1.14-2.87-6.33-1.42-5.42s4,.9,7.43.85a29.71,29.71,0,0,0,4.84-.34A29.53,29.53,0,0,1,228,135S219.14,137,216.84,135.81Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M201.57,137c1.4-2.6,2.48-4.57,2.48-4.57l13.48,13a85.28,85.28,0,0,1,8.2-6.12l1.19,2.12c-2.18,3.69-4.08,11.5-4.13,13.4,0,0-2.07,2.29-3.22,2.48,0,0,14.43,22.85,23.7,34.09s15.54,20.82,19.88,23.93c-8.77-5.06-20.73-21.55-26.41-29.5-6.39-9-18.33-24.89-20.79-26.32s-8.13-2.19-13-10.24C201.06,146.05,200.92,141.48,201.57,137Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M229.64,138.29c-.16,1.33-13.56,13-15,14.28-.1.1-1.15.26-1.44,0-3.56-3.13-19.12-31.39-19.4-32.41s10.07-10.67,13.23-13.27a2.77,2.77,0,0,1,2.49.29C212.73,111.89,229.85,136.57,229.64,138.29Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M228.2,138.29c-.16,1.33-13.56,13-15,14.28s-20.54-31.31-20.84-32.41c-.26-1,11.24-10.51,14.4-13.11a.88.88,0,0,1,1.32.13C211.29,111.89,228.41,136.57,228.2,138.29Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M225.94,136.38c-.15,1.25-12.69,12.12-14,13.36s-19.22-29.29-19.5-30.32,10.52-9.84,13.47-12.27a.83.83,0,0,1,1.24.13C210.12,111.69,226.14,134.77,225.94,136.38Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M217.91,120.45c-2.08-1.25-4.63-5.48-4.86-6.91s-.08-2.72,1-3,4.55,4.19,6.27,5.52,3.79,4.09,2.94,6-4.65,1.14-5.06.86S217.91,120.45,217.91,120.45Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M213.44,110.91c-.66,1.63,3.63,8.14,7.39,10l-1.4,1.6-1.45-.34a11.29,11.29,0,0,1-.07-1.74c-2.08-1.25-4.63-5.48-4.86-6.91A3.23,3.23,0,0,1,213.44,110.91Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M222.73,127c-3.57-1.91-6.37-1.7-8.31-2.48s-2.3-3.79-1-4.29,9.36.79,11.44,1.72,3.06,5.2,3.06,5.2Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M221.17,124.81c2,.38,2.71,0,2.71,0,0,.79.69,1.18,1.53,2.31l-2.68-.08c-3.57-1.91-6.37-1.7-8.31-2.48a2.9,2.9,0,0,1-1.64-2C213.64,124.19,219.16,124.43,221.17,124.81Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M231,130.4c-1.91,2.63-11.25,1.49-13.14,1.2s-3.06-1.47-2.87-2.67c.39-2.42,12.73-2,13.75-1.61S231,130.4,231,130.4Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M215,129.51c1.27,1.27,4.34,2,7.69,2.26a29.85,29.85,0,0,0,4.95.09,38.59,38.59,0,0,1-9.84-.26A3.09,3.09,0,0,1,215,129.51Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M187.24,167.33c19.83,10.09,23.09,9.7,31.6,14.28s6,52.75,5.45,60.18-2.6,36.94-1.46,44.94,5.54,37.7,7.49,42.27,5.67,12.28-.09,16.85-17.94,7.72-44.4,6-55-18-56.24-20.28,12.65-44.27,13.23-52.27a107.57,107.57,0,0,1,3-17.71c.84-3.71-7.58-21.14-8.92-32.28s-13.45-41.87-11.15-47.49,23.37-11.91,37.73-19.06S187.24,167.33,187.24,167.33Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M206.9,179.82a55.25,55.25,0,0,1-18.75,27.3c-10.74-2.63-21.66-7.36-30.46-14.07a127.83,127.83,0,0,0,32,17.49A47,47,0,0,0,206.9,179.82Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M202.85,174.72c-3.8-1.63-8.7-3.87-15.61-7.39,0,0-9.41-11.73-23.76-4.57-5,2.48-10.77,4.86-16.31,7.14a71.7,71.7,0,0,0,38.4,31.34A50.64,50.64,0,0,0,202.85,174.72Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M129.59,331.57c-1.26-2.28,12.65-44.27,13.23-52.27a107.57,107.57,0,0,1,3-17.71c.84-3.71-7.58-21.14-8.92-32.28a59.55,59.55,0,0,0-1.55-7.35l8.94-6.66c5.25,14.63,8.52,40.33,13.49,46.62s17.35,8.85,17.35,8.85-12.23,2.86-17.56,1.72c0,0-5.7,22.56-5.76,33.7s1,28,1.1,30.28c.05.85-.14,3.82-.39,7.22C139.7,338.61,130.3,332.86,129.59,331.57Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M165.73,142.46c-.21,11.92-1,20.11-3.63,22.4,0,0,4.54,19.78,22.67,18.09,6.14-.57,5.55-10.86,2.47-15.62l1.83-14.62Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M163.48,162.76h0c1.55-3.66,2.08-10.78,2.25-20.3l23.34,10.25-1.17,9.38h0C183.76,163.94,163.48,162.76,163.48,162.76Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M101.46,238.86c-4,5.53-9.4,19.24-7.38,25.52s22.83,34.28,32.35,44.75,11.68,12.19,13.34,15.61,9.76,17.57,11.89,19.71,6,2.43,6,2.43a10.13,10.13,0,0,0,8.35,2.57s4.79,3.29,8.58,4.14c0,0,1.25,2.43,2.52,2.64s2.89-2.35.55-7.49-6.18-7.29-6.8-10.57-3.59-10-3.59-10,6.67,6.85,10.78,7.28,4.67-2,2.41-4a52.08,52.08,0,0,1-7.9-8.86,15.74,15.74,0,0,0-11.33-7.14c-5.23-.71-8.91-1.28-10.26-2.28s-8.2-10.71-12.87-21.19-8.87-23.85-20.75-35.61l5.24-9.14Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M174.39,352.94a22.08,22.08,0,0,0-4.93-7.57l-.81-.8c-.24-.24-.66-.56-.76-.7-.41-.53-.76-1.21-1.15-1.83-.76-1.29-1.49-2.6-2.33-3.86a33.77,33.77,0,0,0,1.53,4.3,13.15,13.15,0,0,0,1.07,2.07,8.54,8.54,0,0,0,.83.85l.77.79c1,1.06,2,2.17,3,3.27S173.48,351.73,174.39,352.94Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M165.76,348.46c-.79-1.53-1.72-2.87-2.55-4.27s-1.65-2.77-2.44-4.29a8.8,8.8,0,0,0,1.45,4.94A11.33,11.33,0,0,0,165.76,348.46Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M161.58,349.07a9.22,9.22,0,0,1-4-2.19s-3.84-.28-6-2.43a55.22,55.22,0,0,1-4.76-7.09c0,.05,2.44,2.65,4.16,4.8a5.81,5.81,0,0,0,5.9,2l-.47-2.79S158.81,347.72,161.58,349.07Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M94,257.4c.11,2.6.14,4.68,4,11.52,4.35,7.69,30.5,40.13,36.2,46.12s5.54,6.38,8.91,15.86c-1.52-2.68-2.79-5-3.34-6.16-1.66-3.42-3.82-5.14-13.34-15.61S96.1,270.66,94.08,264.38A15.52,15.52,0,0,1,94,257.4Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M114.48,249.9l-2.12,3.54a12.19,12.19,0,0,1,5,2.94l4.14-7Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M139.54,230.54c5.46-10.74,7.65-28.17,2.72-37.35S128,180.71,125.75,181.82s-8.47,15.41-14.27,22S89.83,229,89.35,230.54s11.45,14.15,33.9,23.4C125.92,255,139.54,230.54,139.54,230.54Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M122.89,238.86l-3.58,7.35s17.64-17.69,25-30.88a53,53,0,0,1-4.74,15.21s-13.62,24.5-16.29,23.4c-3.84-1.58-7.35-3.27-10.56-5Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M190.42,143.53c-1.22-4.91-1.19-9.94-1.48-15-.22-3.76-.41-7.2-3.82-9.44a12.6,12.6,0,0,0-8.55-1.6c-7.88,1-9.58,8.68-9,15.95.46,5.57,2.63,10.91,4.79,16-2.9-.13-6.86-1.65-8.59-4.06a17.17,17.17,0,0,0,4.56,8.34c-8.4-.15-16.2-5.64-20.65-13s-5.85-16.39-5.38-25.08c.56-10.31,3.78-20.64,10.15-28.58,12.82-16,37.53-17.82,52.58-4.1a37.8,37.8,0,0,1,10.8,17.89,59.64,59.64,0,0,1,.49,27.8,93.26,93.26,0,0,0-1.53,10.82c-.12,1.17-1.54,14.78-.72,14.73-5.31.32-11.4-.75-15-4.81,1.61,2.79,3,5.47,4.61,8.26C197,156.58,192.1,150.34,190.42,143.53Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M162.89,125c-2.37-1.4-5.22-2.16-7.42.07-3.24,3.28,1.36,18.56,8.35,14.85,0,0,10.11,14.14,17.53,18.14s12.71,2,15.48-.86,12.26-14.57,14-27c.6-4.43-.05-13.14.09-15,.41-5.71,2.58-10.4-1.93-14.88a26.1,26.1,0,0,0-17.27-7.5,27.92,27.92,0,0,0-21.52,9.41C164.26,108.93,163.23,116.5,162.89,125Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M156.62,129.24c.6-2.8,3-3.36,4.77-1.4s2.12,8.33,1.66,9.26-3.6.87-4.19-1.07,1.23-3.14,3-2.57c0,0,.49-2.82-.94-4.64s-2.94-1.12-3.3-.65A14.25,14.25,0,0,1,156.62,129.24Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M176,116.85a24.52,24.52,0,0,1,2.14-1.77,15.92,15.92,0,0,1,2.42-1.44,8,8,0,0,1,2.69-.9,5.64,5.64,0,0,1,2.73.36l0,.13a12.52,12.52,0,0,1-1.32.42l-1.25.35c-.82.24-1.67.32-2.5.59a19.15,19.15,0,0,0-2.44,1c-.81.4-1.59.86-2.38,1.33Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M207.54,113.64a9.23,9.23,0,0,0-2.42-.87,13,13,0,0,0-2.55-.31c-.87,0-1.73.16-2.58.15a24.22,24.22,0,0,1-2.67-.06l0-.12a6.56,6.56,0,0,1,2.66-1.09,8.1,8.1,0,0,1,2.78.1,11,11,0,0,1,2.62.71,8.34,8.34,0,0,1,2.27,1.39Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M184.43,121.87c0-1.21-.64-2.13-1.36-2.06s-1.28,1.11-1.25,2.32.64,2.13,1.36,2.06S184.46,123.08,184.43,121.87Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M203.5,120.35c0-1.21-.53-2.15-1.12-2.09s-1,1.09-1,2.29.53,2.15,1.12,2.09S203.54,121.55,203.5,120.35Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M190.4,133.61a5.38,5.38,0,0,0,5.89-.06,2.72,2.72,0,0,1-1.52,2.17,3.61,3.61,0,0,1-2.74-.15C191.2,135.19,190.93,134.35,190.4,133.61Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M183.78,140.7a164.67,164.67,0,0,0,16.69-1.11c-1.23,4-4.46,8-9,8C187.44,147.61,184.75,144.28,183.78,140.7Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M187.44,146.29a7.2,7.2,0,0,1,3.84,0,6.16,6.16,0,0,1,5.17-.51,7.76,7.76,0,0,1-4.95,1.86A6.8,6.8,0,0,1,187.44,146.29Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M197.76,143a19.43,19.43,0,0,1-12.23-.47q0-.9-.12-1.8c3.94-.08,10.32-.56,13.73-.94A11.38,11.38,0,0,1,197.76,143Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M166.87,111.84a55.38,55.38,0,0,0,18.95-4.2c1.15-2.65,1.18-5,1.35-7.87a22.78,22.78,0,0,1,2.78,9.76c3.78-.25,7.58-.45,11.37-.69a23.57,23.57,0,0,0,1-9.27,39.83,39.83,0,0,1,2.35,10c2.29-.81,5.18.37,7.57.8,3-6.59,2.76-18.52-3.49-23.52-6.09-4.87-16.68-6.19-24.12-5.11-15.84,2.29-28.29,15.44-27.31,31.83.56,9.34,5.25,18.18,12,24.7A37.89,37.89,0,0,1,166.87,111.84Z",
    transform: "translate(-67.73 -57.8)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 324.34,
    cy: 157.8,
    r: 41.78,
    transform: "matrix(0.25, -0.97, 0.97, 0.25, 22.3, 374.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 300.3,
    y: 141.45,
    width: 48.08,
    height: 32.71,
    rx: 3.43,
    transform: "translate(580.95 257.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303.72,174.16H345a3.43,3.43,0,0,0,3.43-3.43l-24-15.11-24,15.11A3.42,3.42,0,0,0,303.72,174.16Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M303.72,141.45H345a3.43,3.43,0,0,1,3.43,3.42l-24,15.12-24-15.12A3.42,3.42,0,0,1,303.72,141.45Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 620.56,
    cy: 217.93,
    r: 41.78,
    transform: "translate(-100.9 87.89) rotate(-13.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M632.28,209.76h-4.2a14.89,14.89,0,0,0-1.91-4.61l3-3a1,1,0,0,0,0-1.47l-3.3-3.3a1,1,0,0,0-1.47,0l-3,3a14.89,14.89,0,0,0-4.61-1.91v-4.2a1,1,0,0,0-1-1h-4.67a1,1,0,0,0-1,1v4.2a14.93,14.93,0,0,0-4.6,1.91l-3-3a1,1,0,0,0-1.47,0l-3.31,3.3a1.05,1.05,0,0,0,0,1.47l3,3a14.89,14.89,0,0,0-1.91,4.61h-4.21a1,1,0,0,0-1,1v4.67a1,1,0,0,0,1,1h4.21a14.93,14.93,0,0,0,1.91,4.6l-3,3a1.05,1.05,0,0,0,0,1.47l3.31,3.31a1.05,1.05,0,0,0,1.47,0l3-3a14.93,14.93,0,0,0,4.6,1.91V232a1,1,0,0,0,1,1h4.67a1,1,0,0,0,1-1v-4.2a14.89,14.89,0,0,0,4.61-1.91l3,3a1.05,1.05,0,0,0,1.47,0l3.3-3.31a1,1,0,0,0,0-1.47l-3-3a14.93,14.93,0,0,0,1.91-4.6h4.2a1,1,0,0,0,1-1V210.8A1,1,0,0,0,632.28,209.76Zm-18.86,9.82a6.45,6.45,0,1,1,6.44-6.45A6.45,6.45,0,0,1,613.42,219.58Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M613.42,204.16a9,9,0,1,0,9,9A9,9,0,0,0,613.42,204.16Zm0,14.45a5.48,5.48,0,1,1,5.48-5.48A5.48,5.48,0,0,1,613.42,218.61Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M650.22,228.16h-2.14a7.64,7.64,0,0,0-1-2.35l1.52-1.52a.53.53,0,0,0,0-.75l-1.69-1.69a.53.53,0,0,0-.75,0l-1.52,1.52a7.64,7.64,0,0,0-2.35-1v-2.14a.53.53,0,0,0-.53-.53h-2.39a.53.53,0,0,0-.53.53v2.14a7.75,7.75,0,0,0-2.35,1L635,221.85a.53.53,0,0,0-.75,0l-1.69,1.69a.54.54,0,0,0,0,.75l1.52,1.52a7.39,7.39,0,0,0-1,2.35H631a.53.53,0,0,0-.53.53v2.39a.53.53,0,0,0,.53.53h2.15a7.49,7.49,0,0,0,1,2.35l-1.52,1.52a.54.54,0,0,0,0,.75l1.69,1.69a.54.54,0,0,0,.75,0l1.52-1.52a7.49,7.49,0,0,0,2.35,1v2.15a.53.53,0,0,0,.53.53h2.39a.53.53,0,0,0,.53-.53v-2.15a7.39,7.39,0,0,0,2.35-1l1.52,1.52a.54.54,0,0,0,.75,0l1.69-1.69a.53.53,0,0,0,0-.75L647.1,234a7.75,7.75,0,0,0,1-2.35h2.14a.53.53,0,0,0,.53-.53v-2.39A.53.53,0,0,0,650.22,228.16Zm-9.63,5a3.3,3.3,0,1,1,3.29-3.3A3.3,3.3,0,0,1,640.59,233.18Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M640.59,225.3a4.59,4.59,0,1,0,4.58,4.58A4.58,4.58,0,0,0,640.59,225.3Zm0,7.38a2.8,2.8,0,1,1,2.8-2.8A2.8,2.8,0,0,1,640.59,232.68Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 432.06,
    cy: 99.58,
    r: 41.78,
    transform: "translate(-73.68 110.6) rotate(-21.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 408.02,
    y: 79.94,
    width: 48.08,
    height: 41.11,
    rx: 3.3,
    transform: "translate(796.4 143.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M408,88.55H456.1v-5.3a3.31,3.31,0,0,0-3.3-3.31H411.33A3.31,3.31,0,0,0,408,83.25Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M444.62,81.78h0a1,1,0,0,0,1-1V79.08a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V80.8A1,1,0,0,0,444.62,81.78Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M447.41,81.78h0a1,1,0,0,0,1-1V79.08a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V80.8A1,1,0,0,0,447.41,81.78Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M416.72,81.78h0a1,1,0,0,0,1-1V79.08a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V80.8A1,1,0,0,0,416.72,81.78Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M419.51,81.78h0a1,1,0,0,0,1-1V79.08a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V80.8A1,1,0,0,0,419.51,81.78Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.58,
    y: 35.86,
    width: 4.17,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 356.67,
    y: 35.86,
    width: 4.17,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 346.76,
    y: 35.86,
    width: 4.17,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 376.49,
    y: 44.4,
    width: 4.16,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.58,
    y: 44.4,
    width: 4.17,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 356.67,
    y: 44.4,
    width: 4.17,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 346.76,
    y: 44.4,
    width: 4.17,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 376.49,
    y: 52.93,
    width: 4.16,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.58,
    y: 52.93,
    width: 4.17,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 356.67,
    y: 52.93,
    width: 4.17,
    height: 4.17,
    rx: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 551.67,
    cy: 121.05,
    r: 41.78,
    transform: "translate(8.26 367.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 551.67,
    cy: 121.05,
    r: 28.62,
    transform: "translate(8.26 367.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M551.67,92.44a28.62,28.62,0,1,0,28.62,28.61A28.61,28.61,0,0,0,551.67,92.44Zm2.4,53v-3.91a1.31,1.31,0,0,0-1.31-1.32h-2.17a1.31,1.31,0,0,0-1.31,1.32v3.91a24.51,24.51,0,0,1-22-22h3.91a1.32,1.32,0,0,0,1.32-1.31V120a1.32,1.32,0,0,0-1.32-1.32h-3.91a24.51,24.51,0,0,1,22-22v3.91a1.3,1.3,0,0,0,1.31,1.31h2.17a1.3,1.3,0,0,0,1.31-1.31V96.67a24.51,24.51,0,0,1,22,22h-3.91a1.32,1.32,0,0,0-1.32,1.32v2.17a1.32,1.32,0,0,0,1.32,1.31h3.91A24.51,24.51,0,0,1,554.07,145.44Z",
    transform: "translate(-67.73 -57.8)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "translate(466.92 70.08)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34"
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 9.64,
    y: 0
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.82,
    y: 0
  }, "/7")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBanner);
export default __webpack_public_path__ + "static/media/help-banner.b5745375f93905803154fcc71adf4982.svg";
export { ForwardRef as ReactComponent };